var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLoria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109.74,
    height: 100,
    viewBox: "0 0 87.792 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 95h154v57H83z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.559 95.199v37.914c0 2.664.41 5.102 1.242 7.32.824 2.207 2.008 4.11 3.551 5.711 1.543 1.598 3.41 2.84 5.602 3.719 2.183.871 4.64 1.313 7.359 1.313h8.398v-7.04h-7.277c-3.945 0-6.824-1.066-8.633-3.199-1.808-2.129-2.723-5.351-2.723-9.672V95.2zm42.402 49.129a11.506 11.506 0 0 1-4-2.71c-1.121-1.169-1.984-2.571-2.602-4.192-.605-1.625-.918-3.426-.918-5.403 0-1.968.301-3.765.918-5.398.61-1.625 1.473-3.023 2.602-4.2a11.411 11.411 0 0 1 3.992-2.714c1.543-.64 3.223-.957 5.04-.957 1.808 0 3.488.316 5.038.957 1.543.633 2.88 1.547 4 2.715s1.985 2.566 2.594 4.199c.606 1.621.918 3.422.918 5.398 0 1.97-.305 3.77-.918 5.403-.61 1.62-1.473 3.023-2.594 4.191s-2.445 2.078-4 2.711c-1.543.64-3.222.96-5.039.96-1.808 0-3.488-.32-5.039-.96m-2.555-30.832c-2.398.984-4.519 2.352-6.359 4.121-1.84 1.75-3.285 3.863-4.36 6.313-1.062 2.445-1.6 5.14-1.6 8.078 0 2.984.53 5.703 1.6 8.152 1.063 2.45 2.52 4.559 4.36 6.32a19.859 19.859 0 0 0 6.36 4.079 20.367 20.367 0 0 0 7.593 1.44c2.664 0 5.2-.48 7.602-1.44a19.65 19.65 0 0 0 6.351-4.079c1.84-1.761 3.286-3.863 4.36-6.32 1.062-2.45 1.597-5.168 1.597-8.152 0-2.93-.527-5.625-1.597-8.078-1.067-2.45-2.52-4.563-4.36-6.313-1.832-1.762-3.96-3.129-6.351-4.121a19.833 19.833 0 0 0-7.602-1.48c-2.664 0-5.199.488-7.593 1.48m49.84-1.496c-2.399 0-4.422.39-6.079 1.191-1.648.801-3.09 2.13-4.32 4h-.16v-4.398h-6.719v38.398h7.04v-17.91c0-5.227.945-8.961 2.831-11.203 1.887-2.238 4.543-3.36 7.961-3.36h1.031v-6.71h-1.601zm8.242 39.199h7.039V112.8h-7.04zm.36-49.88c-.72.88-1.079 1.849-1.079 2.919 0 1.066.36 2.043 1.078 2.922.711.879 1.77 1.32 3.152 1.32 1.383 0 2.442-.441 3.153-1.32.719-.88 1.078-1.848 1.078-2.922 0-1.063-.36-2.031-1.078-2.918-.711-.879-1.77-1.32-3.153-1.32-1.382 0-2.44.441-3.152 1.32m27.082 12.207c-2.45 1.008-4.531 2.402-6.242 4.16-1.703 1.754-3.008 3.832-3.918 6.234-.906 2.399-1.356 4.957-1.356 7.68 0 2.824.465 5.477 1.395 7.957.926 2.473 2.238 4.64 3.918 6.48a18.686 18.686 0 0 0 5.953 4.36c2.29 1.066 4.824 1.602 7.602 1.602 2.445 0 4.445-.344 5.992-1.04a21.648 21.648 0 0 0 4.398-2.64v-8.313c-1.222 1.543-2.633 2.81-4.23 3.793-1.602.985-3.41 1.481-5.442 1.481-1.863 0-3.55-.344-5.082-1.043a12.108 12.108 0 0 1-3.957-2.84 13.002 13.002 0 0 1-2.601-4.191 14.016 14.016 0 0 1-.91-5.04c0-1.808.285-3.527.87-5.16a12.921 12.921 0 0 1 2.52-4.28c1.09-1.223 2.426-2.2 3.992-2.91 1.567-.712 3.313-1.083 5.239-1.083 1.593 0 3.144.227 4.64.68a12.329 12.329 0 0 1 4 2.035 9.986 9.986 0 0 1 2.801 3.398c.688 1.36 1.031 2.946 1.031 4.762v21.598h7.04v-20.96c0-2.767-.446-5.278-1.352-7.52-.903-2.23-2.192-4.153-3.88-5.75-1.679-1.602-3.71-2.825-6.112-3.68-2.399-.848-5.063-1.281-8-1.281-3.086 0-5.864.504-8.32 1.511"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.559.2v37.913c0 2.664.41 5.102 1.242 7.32.824 2.208 2.008 4.11 3.55 5.711 1.544 1.598 3.41 2.84 5.602 3.72 2.184.87 4.64 1.312 7.36 1.312h8.398v-7.04h-7.277c-3.946 0-6.825-1.066-8.633-3.199-1.809-2.128-2.723-5.351-2.723-9.671V.2zM42.96 49.327a11.506 11.506 0 0 1-4-2.71c-1.122-1.169-1.985-2.571-2.602-4.192-.605-1.625-.918-3.426-.918-5.402 0-1.97.3-3.766.918-5.399.61-1.625 1.473-3.023 2.602-4.199a11.411 11.411 0 0 1 3.992-2.715c1.543-.64 3.222-.957 5.039-.957 1.808 0 3.488.317 5.039.957 1.543.633 2.879 1.547 4 2.715s1.984 2.566 2.594 4.2c.605 1.62.918 3.421.918 5.398 0 1.968-.305 3.77-.918 5.402-.61 1.621-1.473 3.023-2.594 4.191a11.468 11.468 0 0 1-4 2.711c-1.543.64-3.223.961-5.04.961-1.808 0-3.487-.32-5.038-.96m-2.555-30.833c-2.398.985-4.52 2.352-6.36 4.121-1.84 1.75-3.285 3.864-4.359 6.313-1.062 2.445-1.601 5.14-1.601 8.078 0 2.984.53 5.703 1.601 8.152 1.063 2.45 2.52 4.559 4.36 6.32a19.859 19.859 0 0 0 6.36 4.079A20.367 20.367 0 0 0 47.991 57c2.664 0 5.2-.48 7.601-1.441a19.65 19.65 0 0 0 6.352-4.078c1.84-1.762 3.285-3.864 4.36-6.32 1.062-2.45 1.597-5.169 1.597-8.153 0-2.93-.527-5.625-1.598-8.078-1.066-2.45-2.519-4.563-4.359-6.313-1.832-1.761-3.96-3.129-6.352-4.12a19.833 19.833 0 0 0-7.601-1.481c-2.664 0-5.2.488-7.594 1.48M90.238 17c-2.398 0-4.422.39-6.078 1.192-1.648.8-3.09 2.128-4.32 4h-.16v-4.399h-6.72v38.398H80v-17.91c0-5.226.945-8.96 2.832-11.203 1.887-2.238 4.543-3.36 7.96-3.36h1.032v-6.71h-1.602zm8.242 39.2h7.04V17.8h-7.04zm.36-49.88c-.72.879-1.078 1.848-1.078 2.918 0 1.067.359 2.043 1.078 2.922.71.879 1.77 1.32 3.152 1.32s2.441-.441 3.152-1.32c.719-.879 1.078-1.848 1.078-2.922 0-1.062-.359-2.031-1.078-2.918-.71-.879-1.77-1.32-3.152-1.32s-2.441.441-3.152 1.32m27.082 12.207c-2.45 1.008-4.532 2.402-6.243 4.16-1.703 1.754-3.007 3.832-3.918 6.235-.906 2.398-1.355 4.957-1.355 7.68 0 2.824.465 5.476 1.394 7.956.926 2.473 2.239 4.641 3.918 6.48a18.686 18.686 0 0 0 5.954 4.36c2.289 1.067 4.824 1.602 7.601 1.602 2.445 0 4.445-.344 5.992-1.04a21.648 21.648 0 0 0 4.399-2.64v-8.312c-1.223 1.543-2.633 2.808-4.23 3.793-1.602.984-3.41 1.48-5.442 1.48-1.863 0-3.55-.344-5.082-1.043a12.108 12.108 0 0 1-3.957-2.84 13.002 13.002 0 0 1-2.602-4.191 14.016 14.016 0 0 1-.91-5.04c0-1.808.285-3.526.871-5.16a12.921 12.921 0 0 1 2.52-4.28c1.09-1.223 2.426-2.2 3.992-2.91 1.566-.712 3.312-1.083 5.238-1.083 1.594 0 3.145.227 4.64.68a12.329 12.329 0 0 1 4 2.035 9.986 9.986 0 0 1 2.802 3.399c.687 1.359 1.03 2.945 1.03 4.761v21.598h7.04v-20.96c0-2.766-.445-5.278-1.352-7.52-.902-2.23-2.191-4.152-3.879-5.75-1.68-1.602-3.71-2.824-6.113-3.68-2.398-.848-5.062-1.281-8-1.281-3.086 0-5.863.504-8.32 1.512"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h154v57H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 14h124v206H13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.367 20.816v-3.047c0-.555.207-.824.64-.824.434 0 .65.27.65.824v3.047c0 .55-.216.824-.65.824-.421 0-.64-.273-.64-.824m-1.71-5.273c-.579.671-.864 1.601-.864 2.746v1.992c0 1.152.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.598.863-2.75v-1.992c0-1.16-.285-2.075-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.782h2.566v9.063h-2.566zm7.734 0h2.57v9.063H31.2zm8.367 6.055v-3.047c0-.555.211-.824.64-.824.435 0 .65.27.65.824v3.047c0 .55-.215.824-.65.824-.421 0-.64-.273-.64-.824m-1.71-5.273c-.575.672-.864 1.601-.864 2.746v1.992c0 1.152.29 2.07.863 2.75.579.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.598.866-2.75v-1.992c0-1.16-.289-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.773.336-2.359 1.008m8.809-.782h2.566v9.063h-2.566zm7.734 0h2.57v9.063h-2.57zm8.371 6.055V17.77c0-.554.208-.824.637-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.637-.273-.637-.824m-1.714-5.273c-.575.672-.864 1.601-.864 2.746v1.992c0 1.152.29 2.07.864 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.362-1.008.575-.672.864-1.598.864-2.75v-1.992c0-1.16-.29-2.074-.864-2.746-.578-.672-1.363-1.008-2.363-1.008-.988 0-1.773.336-2.36 1.008m9.442 5.273V17.77c0-.554.207-.824.64-.824.43 0 .65.27.65.824v3.047c0 .55-.22.824-.65.824-.425 0-.64-.273-.64-.824m-1.71-5.273c-.579.672-.864 1.601-.864 2.746v1.992c0 1.152.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.289-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008M16.367 37.137V34.09c0-.555.207-.824.64-.824.434 0 .65.27.65.824v3.047c0 .55-.216.824-.65.824-.421 0-.64-.274-.64-.824m-1.71-5.274c-.579.672-.864 1.602-.864 2.746v1.993c0 1.152.285 2.07.863 2.75.575.671 1.36 1.007 2.36 1.007.992 0 1.785-.336 2.36-1.007.577-.672.862-1.598.862-2.75v-1.993c0-1.16-.285-2.074-.863-2.746-.574-.672-1.36-1.007-2.36-1.007-.991 0-1.777.335-2.359 1.007m8.809-.785h2.566v9.067h-2.566zm7.734 0h2.57v9.067H31.2zm8.367 6.059V34.09c0-.555.211-.824.641-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.274c-.575.672-.864 1.602-.864 2.746v1.993c0 1.152.29 2.07.864 2.75.578.672 1.359 1.007 2.359 1.007.992 0 1.785-.335 2.36-1.007.578-.672.867-1.598.867-2.75v-1.993c0-1.16-.29-2.074-.868-2.746-.574-.672-1.359-1.007-2.359-1.007-.992 0-1.773.335-2.36 1.007m8.81-.785h2.566v9.067h-2.567zm7.734 0h2.57v9.067h-2.57zm7.738 0h2.566v9.067h-2.566zm7.726 0h2.57v9.067h-2.57zm-53.496 22.38v-3.052c0-.55.208-.82.641-.82.434 0 .649.27.649.82v3.051c0 .551-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.273c-.579.672-.864 1.601-.864 2.746v1.992c0 1.148.285 2.07.864 2.75.574.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.578-.672.863-1.602.863-2.75V50.93c0-1.16-.285-2.074-.864-2.746-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008m8.81-.785h2.566v9.066h-2.567zm7.734 0h2.57v9.066H31.2zm7.738 0h2.566v9.066h-2.566zm8.36 6.058v-3.05c0-.551.206-.82.64-.82.43 0 .648.269.648.82v3.05c0 .551-.218.824-.648.824-.426 0-.64-.273-.64-.824m-1.712-5.273c-.578.672-.867 1.601-.867 2.746v1.992c0 1.149.29 2.07.867 2.75.575.672 1.36 1.008 2.36 1.008.992 0 1.781-.336 2.36-1.008.573-.672.862-1.601.862-2.75V50.93c0-1.16-.289-2.074-.863-2.746-.578-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m9.446 5.273v-3.05c0-.551.207-.82.64-.82s.649.269.649.82v3.05c0 .551-.215.824-.649.824-.425 0-.64-.273-.64-.824m-1.711-5.273c-.578.672-.863 1.601-.863 2.746v1.992c0 1.149.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.863-1.601.863-2.75V50.93c0-1.16-.285-2.074-.863-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m8.817-.785h2.567v9.066h-2.567zm8.36 6.058v-3.05c0-.551.207-.82.64-.82.43 0 .649.269.649.82v3.05c0 .551-.22.824-.649.824-.426 0-.64-.273-.64-.824m-1.711-5.273c-.578.672-.864 1.601-.864 2.746v1.992c0 1.149.286 2.07.864 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.358-1.008.575-.672.864-1.601.864-2.75V50.93c0-1.16-.29-2.074-.864-2.746-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008M16.369 69.778v-3.05c0-.552.207-.825.64-.825.434 0 .649.273.649.824v3.05c0 .552-.215.825-.649.825-.422 0-.64-.273-.64-.824m-1.711-5.274c-.578.672-.863 1.602-.863 2.743v1.992c0 1.152.285 2.074.863 2.754.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.863-1.602.863-2.754v-1.992c0-1.157-.285-2.07-.863-2.743-.575-.671-1.36-1.007-2.36-1.007-.992 0-1.777.336-2.36 1.007m8.81-.785h2.566v9.067h-2.567zm7.734 0h2.57v9.067H31.2zm8.367 6.059v-3.05c0-.552.21-.825.64-.825.434 0 .65.273.65.824v3.05c0 .552-.216.825-.65.825-.421 0-.64-.273-.64-.824m-1.71-5.273c-.575.671-.864 1.601-.864 2.742v1.992c0 1.152.289 2.074.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.867-1.602.867-2.754v-1.992c0-1.156-.289-2.07-.867-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.359 1.008m8.809-.786h2.566v9.067h-2.566zm8.367 6.059v-3.05c0-.552.207-.825.64-.825s.649.273.649.824v3.05c0 .552-.215.825-.648.825-.426 0-.641-.273-.641-.824m-1.711-5.273c-.578.671-.863 1.601-.863 2.742v1.992c0 1.152.285 2.074.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.602.863-2.754v-1.992c0-1.156-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m9.45 5.273v-3.05c0-.552.206-.825.636-.825.434 0 .648.273.648.824v3.05c0 .552-.214.825-.648.825-.422 0-.637-.273-.637-.824m-1.715-5.273c-.574.671-.863 1.601-.863 2.742v1.992c0 1.152.29 2.074.863 2.754.579.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.156-.289-2.07-.863-2.742-.578-.672-1.363-1.008-2.363-1.008-.988 0-1.774.336-2.36 1.008m8.809-.786h2.57v9.067h-2.57zM16.368 86.1v-3.051c0-.551.207-.825.64-.825.434 0 .65.274.65.825v3.05c0 .551-.216.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.742v1.992c0 1.153.285 2.075.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.601.863-2.754v-1.992c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.785h2.566v9.066h-2.566zm7.734 0h2.57v9.066H31.2zm8.367 6.058v-3.05c0-.551.211-.825.64-.825.435 0 .65.274.65.825v3.05c0 .551-.215.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.575.672-.864 1.602-.864 2.742v1.992c0 1.153.29 2.075.863 2.754.579.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.601.866-2.754v-1.992c0-1.16-.289-2.07-.867-2.742-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.773.336-2.359 1.008m9.442 5.273v-3.05c0-.551.207-.825.64-.825.43 0 .649.274.649.825v3.05c0 .551-.219.825-.649.825-.425 0-.64-.274-.64-.825m-1.711-5.273c-.578.672-.867 1.602-.867 2.742v1.992c0 1.153.289 2.075.867 2.754.574.672 1.36 1.008 2.36 1.008.991 0 1.78-.336 2.359-1.008.574-.672.863-1.601.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.742-.578-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m9.446 5.273v-3.05c0-.551.207-.825.64-.825s.65.274.65.825v3.05c0 .551-.216.825-.65.825-.425 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.742v1.992c0 1.153.285 2.075.863 2.754.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.862-1.601.862-2.754v-1.992c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m9.45 5.273v-3.05c0-.551.207-.825.636-.825.434 0 .649.274.649.825v3.05c0 .551-.215.825-.649.825-.422 0-.637-.274-.637-.825m-1.714-5.273c-.575.672-.864 1.602-.864 2.742v1.992c0 1.153.29 2.075.864 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.362-1.008.575-.672.864-1.601.864-2.754v-1.992c0-1.16-.29-2.07-.864-2.742-.578-.672-1.363-1.008-2.363-1.008-.988 0-1.773.336-2.36 1.008m8.81-.785h2.57v9.066h-2.57zm-53.497 22.375v-3.047c0-.55.207-.824.64-.824.435 0 .65.273.65.824v3.047c0 .555-.215.824-.65.824-.421 0-.64-.27-.64-.824m-1.71-5.27c-.579.672-.864 1.598-.864 2.743v1.992c0 1.152.285 2.074.863 2.754.575.672 1.36 1.007 2.36 1.007.992 0 1.785-.335 2.36-1.007.577-.672.862-1.602.862-2.754v-1.992c0-1.16-.285-2.07-.863-2.743-.574-.672-1.36-1.007-2.36-1.007-.991 0-1.777.336-2.359 1.007m8.809-.785h2.566v9.067h-2.566zm7.734 0h2.57v9.067H31.2zm8.368 6.055v-3.047c0-.55.21-.824.64-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.422 0-.64-.27-.64-.824m-1.711-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.29 2.074.864 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.358-1.008.579-.672.868-1.602.868-2.754v-1.992c0-1.16-.29-2.07-.868-2.743-.574-.671-1.359-1.007-2.359-1.007-.992 0-1.773.336-2.36 1.007m8.81-.785h2.566v9.067h-2.567zm7.734 0h2.57v9.067H54.4zm8.37 6.055v-3.047c0-.55.208-.824.638-.824.433 0 .648.273.648.824v3.047c0 .555-.215.824-.648.824-.422 0-.637-.27-.637-.824m-1.715-5.27c-.574.672-.863 1.598-.863 2.743v1.992c0 1.152.289 2.074.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.743-.578-.671-1.364-1.007-2.364-1.007-.988 0-1.773.336-2.359 1.007m9.441 5.27v-3.047c0-.55.207-.824.641-.824.43 0 .648.273.648.824v3.047c0 .555-.218.824-.648.824-.426 0-.64-.27-.64-.824m-1.712-5.27c-.578.672-.863 1.598-.863 2.743v1.992c0 1.152.285 2.074.863 2.754.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.29-2.07-.864-2.743-.574-.671-1.36-1.007-2.36-1.007-.991 0-1.776.336-2.359 1.007m-52.418 21.59v-3.046c0-.551.208-.825.641-.825.434 0 .649.274.649.825v3.046c0 .555-.215.825-.649.825-.422 0-.64-.27-.64-.825m-1.711-5.27c-.579.673-.864 1.599-.864 2.743v1.992c0 1.153.285 2.075.864 2.754.574.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.578-.672.863-1.601.863-2.754v-1.992c0-1.16-.285-2.07-.864-2.742-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008m8.81-.785h2.566v9.062h-2.567zm7.734 0h2.57v9.062H31.2zm8.367 6.054v-3.046c0-.551.21-.825.64-.825.434 0 .649.274.649.825v3.046c0 .555-.215.825-.649.825-.421 0-.64-.27-.64-.825m-1.711-5.269c-.574.672-.863 1.598-.863 2.742v1.992c0 1.153.289 2.075.863 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.867-1.601.867-2.754v-1.992c0-1.16-.29-2.07-.867-2.742-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.36 1.008m8.81-.785h2.566v9.062h-2.567zm7.734 0h2.57v9.062H54.4zm7.738 0h2.567v9.062h-2.567zm7.727 0h2.57v9.062h-2.57zm-53.496 22.375v-3.047c0-.55.207-.824.64-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.421 0-.64-.27-.64-.824m-1.711-5.27c-.578.672-.863 1.598-.863 2.743v1.992c0 1.152.285 2.074.863 2.754.574.672 1.36 1.007 2.36 1.007.991 0 1.784-.335 2.359-1.007.578-.672.863-1.602.863-2.754v-1.992c0-1.16-.285-2.07-.863-2.743-.575-.672-1.36-1.007-2.36-1.007-.992 0-1.777.335-2.36 1.007m8.81-.785h2.566v9.063h-2.567zm7.734 0h2.57v9.063h-2.57zm7.738 0h2.567v9.063h-2.567zm8.36 6.055v-3.047c0-.55.207-.824.64-.824.43 0 .649.273.649.824v3.047c0 .555-.22.824-.649.824-.426 0-.64-.27-.64-.824m-1.711-5.27c-.578.672-.867 1.598-.867 2.743v1.992c0 1.152.289 2.074.867 2.754.574.672 1.36 1.007 2.36 1.007.991 0 1.78-.335 2.358-1.007.575-.672.864-1.602.864-2.754v-1.992c0-1.16-.29-2.07-.864-2.743-.578-.671-1.359-1.007-2.359-1.007-.992 0-1.777.336-2.36 1.007m9.446 5.27v-3.047c0-.55.207-.824.64-.824s.65.273.65.824v3.047c0 .555-.216.824-.65.824-.425 0-.64-.27-.64-.824m-1.71-5.27c-.579.672-.864 1.598-.864 2.743v1.992c0 1.152.285 2.074.863 2.754.574.672 1.36 1.007 2.36 1.007.992 0 1.785-.335 2.359-1.007.578-.672.863-1.602.863-2.754v-1.992c0-1.16-.285-2.07-.863-2.743-.574-.671-1.36-1.007-2.36-1.007-.992 0-1.777.336-2.359 1.007m8.816-.785h2.567v9.063h-2.567zm8.36 6.055v-3.047c0-.55.207-.824.64-.824.43 0 .649.273.649.824v3.047c0 .555-.219.824-.648.824-.426 0-.641-.27-.641-.824m-1.711-5.27c-.578.672-.863 1.598-.863 2.743v1.992c0 1.152.285 2.074.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.289-2.07-.863-2.743-.574-.671-1.36-1.007-2.36-1.007-.992 0-1.777.336-2.359 1.007m-52.418 21.59v-3.046c0-.551.207-.825.64-.825.434 0 .65.274.65.825v3.046c0 .555-.216.825-.65.825-.421 0-.64-.27-.64-.825m-1.71-5.27c-.579.673-.864 1.599-.864 2.743v1.992c0 1.153.285 2.07.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.601.863-2.754v-1.992c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.785h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.367 6.054v-3.046c0-.551.211-.825.64-.825.435 0 .65.274.65.825v3.046c0 .555-.215.825-.65.825-.421 0-.64-.27-.64-.825m-1.71-5.269c-.575.672-.864 1.598-.864 2.742v1.992c0 1.153.29 2.07.863 2.754.579.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.601.866-2.754v-1.992c0-1.16-.289-2.07-.867-2.742-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.773.336-2.359 1.008m8.809-.785h2.566v9.062h-2.566zm8.367 6.055v-3.047c0-.551.207-.825.64-.825s.65.274.65.825v3.047c0 .554-.216.824-.65.824-.425 0-.64-.27-.64-.824m-1.71-5.27c-.579.672-.864 1.598-.864 2.742v1.992c0 1.153.285 2.07.863 2.754.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.862-1.601.862-2.754v-1.992c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m9.45 5.27v-3.047c0-.551.207-.825.636-.825.434 0 .649.274.649.825v3.047c0 .554-.215.824-.649.824-.422 0-.637-.27-.637-.824m-1.714-5.27c-.575.672-.864 1.598-.864 2.742v1.992c0 1.153.29 2.07.864 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.362-1.008.575-.672.864-1.601.864-2.754v-1.992c0-1.16-.29-2.07-.864-2.742-.578-.672-1.363-1.008-2.363-1.008-.988 0-1.773.336-2.36 1.008m8.81-.785h2.57v9.062h-2.57zm-53.497 22.375v-3.047c0-.55.207-.824.64-.824.435 0 .65.273.65.824v3.047c0 .55-.215.824-.65.824-.421 0-.64-.273-.64-.824m-1.71-5.27c-.579.672-.864 1.598-.864 2.743v1.992c0 1.152.285 2.07.863 2.75.575.676 1.36 1.011 2.36 1.011.992 0 1.785-.335 2.36-1.011.577-.672.862-1.598.862-2.75v-1.992c0-1.16-.285-2.07-.863-2.743-.574-.672-1.36-1.011-2.36-1.011-.991 0-1.777.34-2.359 1.011m8.809-.785h2.566v9.063h-2.566zm7.734 0h2.57v9.063h-2.57zm8.368 6.055v-3.047c0-.55.21-.824.64-.824.434 0 .649.273.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.29 2.07.864 2.75.578.676 1.36 1.011 2.36 1.011.991 0 1.784-.335 2.358-1.011.579-.672.868-1.598.868-2.75v-1.992c0-1.16-.29-2.07-.868-2.743-.574-.671-1.359-1.011-2.359-1.011-.992 0-1.773.34-2.36 1.011m9.442 5.27v-3.047c0-.55.207-.824.64-.824.43 0 .65.273.65.824v3.047c0 .55-.22.824-.65.824-.425 0-.64-.273-.64-.824m-1.71-5.27c-.579.672-.868 1.598-.868 2.743v1.992c0 1.152.29 2.07.867 2.75.574.676 1.36 1.011 2.36 1.011.992 0 1.78-.335 2.359-1.011.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.289-2.07-.863-2.743-.578-.671-1.36-1.011-2.36-1.011-.992 0-1.777.34-2.359 1.011m9.445 5.27v-3.047c0-.55.208-.824.641-.824s.649.273.649.824v3.047c0 .55-.215.824-.649.824-.426 0-.64-.273-.64-.824m-1.711-5.27c-.579.672-.864 1.598-.864 2.743v1.992c0 1.152.285 2.07.864 2.75.574.676 1.359 1.011 2.359 1.011.992 0 1.785-.335 2.36-1.011.578-.672.863-1.598.863-2.75v-1.992c0-1.16-.285-2.07-.864-2.743-.574-.671-1.359-1.011-2.359-1.011-.992 0-1.777.34-2.36 1.011m9.45 5.27v-3.047c0-.55.207-.824.637-.824.433 0 .648.273.648.824v3.047c0 .55-.215.824-.648.824-.422 0-.637-.273-.637-.824m-1.715-5.27c-.574.672-.863 1.598-.863 2.743v1.992c0 1.152.289 2.07.863 2.75.578.676 1.36 1.011 2.36 1.011.992 0 1.785-.335 2.363-1.011.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.29-2.07-.863-2.743-.578-.671-1.364-1.011-2.364-1.011-.988 0-1.773.34-2.359 1.011m8.809-.785h2.57v9.063h-2.57zM16.37 184.017v-3.047c0-.554.207-.824.64-.824.434 0 .649.27.649.824v3.047c0 .551-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.273c-.578.672-.864 1.601-.864 2.746v1.992c0 1.152.286 2.07.864 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.358-1.008.579-.672.864-1.598.864-2.75v-1.992c0-1.16-.285-2.074-.864-2.746-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008m8.81-.781h2.566v9.062h-2.567zm7.734 0h2.57v9.062h-2.57zm8.367 6.054v-3.047c0-.554.21-.824.64-.824.434 0 .649.27.649.824v3.047c0 .551-.215.824-.648.824-.422 0-.641-.273-.641-.824m-1.711-5.273c-.574.672-.863 1.601-.863 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.867-1.598.867-2.75v-1.992c0-1.16-.29-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.359 1.008m8.809-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.371 6.054v-3.047c0-.554.207-.824.637-.824.433 0 .648.27.648.824v3.047c0 .551-.215.825-.648.825-.422 0-.637-.274-.637-.825m-1.715-5.273c-.574.672-.863 1.602-.863 2.746v1.992c0 1.153.29 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.597.863-2.75v-1.992c0-1.16-.289-2.074-.863-2.746-.578-.672-1.363-1.008-2.363-1.008-.989 0-1.774.336-2.36 1.008m9.442 5.273v-3.047c0-.554.207-.824.64-.824.43 0 .649.27.649.824v3.047c0 .551-.219.825-.649.825-.425 0-.64-.274-.64-.825m-1.711-5.273c-.578.672-.863 1.602-.863 2.746v1.992c0 1.153.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.574-.672.863-1.597.863-2.75v-1.992c0-1.16-.29-2.074-.863-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008M16.37 200.338v-3.047c0-.555.207-.824.64-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.421 0-.64-.273-.64-.824m-1.711-5.273c-.578.671-.863 1.601-.863 2.746v1.992c0 1.152.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.863-1.598.863-2.75v-1.992c0-1.16-.285-2.075-.863-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m8.81-.782h2.566v9.063h-2.567zm7.734 0h2.57v9.063h-2.57zm8.367 6.055v-3.047c0-.555.211-.824.64-.824.434 0 .65.27.65.824v3.047c0 .55-.216.824-.65.824-.421 0-.64-.273-.64-.824m-1.71-5.273c-.575.671-.864 1.601-.864 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.867-1.598.867-2.75v-1.992c0-1.16-.289-2.075-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.359 1.008m8.809-.782h2.566v9.063h-2.566zm7.734 0h2.57v9.063h-2.57zm7.738 0h2.567v9.063h-2.567zm7.727 0h2.57v9.063h-2.57zM16.37 216.658v-3.047c0-.554.207-.824.64-.824.434 0 .65.27.65.824v3.047c0 .551-.216.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.746v1.992c0 1.153.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.597.863-2.75v-1.992c0-1.16-.285-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm7.738 0h2.567v9.062H38.94zm8.36 6.054v-3.047c0-.554.207-.824.64-.824.43 0 .649.27.649.824v3.047c0 .551-.219.825-.648.825-.426 0-.641-.274-.641-.825m-1.711-5.273c-.578.672-.867 1.602-.867 2.746v1.992c0 1.153.289 2.07.867 2.75.574.672 1.36 1.008 2.36 1.008.992 0 1.78-.336 2.359-1.008.574-.672.863-1.597.863-2.75v-1.992c0-1.16-.289-2.074-.863-2.746-.578-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m9.445 5.273v-3.047c0-.554.207-.824.64-.824s.65.27.65.824v3.047c0 .551-.215.825-.65.825-.425 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.746v1.992c0 1.153.285 2.07.863 2.75.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.862-1.597.862-2.75v-1.992c0-1.16-.285-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m8.817-.781h2.566v9.062H62.14zm8.36 6.054v-3.046c0-.555.206-.825.64-.825.43 0 .648.27.648.825v3.046c0 .551-.218.825-.648.825-.426 0-.64-.274-.64-.825m-1.712-5.273c-.578.672-.863 1.602-.863 2.746v1.992c0 1.153.285 2.07.863 2.75.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.573-.672.862-1.597.862-2.75v-1.992c0-1.16-.289-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m9.446-60.008v-3.047c0-.55.21-.824.64-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.422 0-.64-.27-.64-.824m-1.711-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.29 2.07.864 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.358-1.008.579-.672.868-1.602.868-2.754v-1.992c0-1.16-.29-2.07-.868-2.742-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.773.336-2.36 1.008m8.81-.786h2.566v9.063H85.33zm7.734 0h2.57v9.063h-2.57zm8.37 6.055v-3.047c0-.55.208-.824.638-.824.433 0 .648.273.648.824v3.047c0 .555-.215.824-.648.824-.422 0-.637-.27-.637-.824m-1.715-5.27c-.574.672-.863 1.598-.863 2.743v1.992c0 1.152.289 2.07.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.742-.578-.672-1.364-1.008-2.364-1.008-.988 0-1.773.336-2.359 1.008m8.809-.786h2.57v9.063h-2.57zm8.367 6.055v-3.047c0-.55.21-.824.64-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.421 0-.64-.27-.64-.824m-1.711-5.27c-.574.672-.863 1.598-.863 2.743v1.992c0 1.152.289 2.07.863 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.867-1.602.867-2.754v-1.992c0-1.16-.29-2.07-.867-2.742-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.36 1.008m9.45 5.27v-3.048c0-.55.207-.824.64-.824.43 0 .65.273.65.824v3.047c0 .555-.22.824-.65.824-.425 0-.64-.27-.64-.824m-1.71-5.27c-.579.672-.868 1.598-.868 2.743v1.992c0 1.152.29 2.07.867 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.78-.336 2.359-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.805-.786h2.57v9.063h-2.57zm-53.496 22.375v-3.046c0-.551.21-.825.64-.825.434 0 .649.274.649.825v3.046c0 .551-.215.825-.648.825-.422 0-.641-.274-.641-.825m-1.711-5.27c-.574.673-.863 1.599-.863 2.743v1.992c0 1.153.289 2.07.863 2.75.578.676 1.36 1.012 2.36 1.012.992 0 1.785-.336 2.359-1.012.578-.672.867-1.597.867-2.75v-1.992c0-1.16-.29-2.07-.867-2.742-.574-.672-1.36-1.012-2.36-1.012-.992 0-1.773.34-2.359 1.012m8.809-.785h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.371 6.054v-3.046c0-.551.207-.825.637-.825.433 0 .648.274.648.825v3.046c0 .551-.215.825-.648.825-.422 0-.637-.274-.637-.825m-1.715-5.269c-.574.672-.863 1.598-.863 2.742v1.992c0 1.153.29 2.07.863 2.75.578.676 1.36 1.012 2.36 1.012.992 0 1.785-.336 2.363-1.012.574-.671.863-1.597.863-2.75v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.363-1.012-2.363-1.012-.989 0-1.774.34-2.36 1.012m9.442 5.27v-3.047c0-.551.207-.825.64-.825.43 0 .649.274.649.825v3.046c0 .551-.219.825-.649.825-.425 0-.64-.274-.64-.825m-1.711-5.269c-.578.672-.863 1.598-.863 2.742v1.992c0 1.153.285 2.07.863 2.75.574.676 1.36 1.012 2.36 1.012.991 0 1.784-.336 2.359-1.012.574-.671.863-1.597.863-2.75v-1.992c0-1.16-.29-2.07-.863-2.742-.575-.672-1.36-1.012-2.36-1.012-.992 0-1.777.34-2.36 1.012m9.446 5.27v-3.047c0-.551.211-.825.64-.825.434 0 .65.274.65.825v3.046c0 .551-.216.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.269c-.575.672-.864 1.598-.864 2.742v1.992c0 1.153.289 2.07.863 2.75.578.676 1.36 1.012 2.36 1.012.992 0 1.785-.336 2.359-1.012.578-.671.867-1.597.867-2.75v-1.992c0-1.16-.289-2.07-.867-2.742-.574-.672-1.36-1.012-2.36-1.012-.992 0-1.773.34-2.359 1.012m9.45 5.27v-3.047c0-.551.206-.825.64-.825.43 0 .648.274.648.825v3.046c0 .551-.218.825-.648.825-.426 0-.64-.274-.64-.825m-1.712-5.269c-.578.672-.867 1.598-.867 2.742v1.992c0 1.153.29 2.07.867 2.75.575.676 1.36 1.012 2.36 1.012.992 0 1.781-.336 2.36-1.012.574-.671.863-1.597.863-2.75v-1.992c0-1.16-.29-2.07-.864-2.742-.578-.672-1.36-1.012-2.36-1.012-.991 0-1.776.34-2.359 1.012m8.805-.785h2.57v9.062h-2.57zm-53.496 22.375v-3.047c0-.555.211-.824.64-.824.434 0 .65.27.65.824v3.047c0 .55-.216.824-.65.824-.421 0-.64-.273-.64-.824m-1.71-5.274c-.575.672-.864 1.602-.864 2.747v1.992c0 1.152.29 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.598.866-2.75v-1.992c0-1.16-.289-2.075-.867-2.747-.574-.671-1.36-1.007-2.36-1.007-.991 0-1.773.336-2.359 1.007m8.809-.78h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.371 6.054v-3.047c0-.555.207-.824.637-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.637-.273-.637-.824m-1.714-5.274c-.575.672-.864 1.602-.864 2.747v1.992c0 1.152.29 2.07.864 2.75.578.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.363-1.008.575-.672.864-1.598.864-2.75v-1.992c0-1.16-.29-2.075-.864-2.747-.578-.671-1.363-1.007-2.363-1.007-.988 0-1.773.336-2.36 1.007m8.81-.78h2.57v9.062h-2.57zm7.737 0h2.567v9.062h-2.567zm8.368 6.054v-3.047c0-.555.207-.824.64-.824.43 0 .649.27.649.824v3.047c0 .55-.219.824-.649.824-.425 0-.64-.273-.64-.824m-1.711-5.273c-.578.671-.867 1.601-.867 2.746v1.992c0 1.152.289 2.07.867 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.78-.336 2.359-1.008.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.29-2.075-.863-2.746-.579-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m9.438 5.273v-3.047c0-.555.207-.824.64-.824s.65.27.65.824v3.047c0 .55-.215.824-.65.824-.425 0-.64-.273-.64-.824m-1.71-5.273c-.579.671-.864 1.601-.864 2.746v1.992c0 1.152.285 2.07.863 2.75.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.862-1.598.862-2.75v-1.992c0-1.16-.285-2.075-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m-52.418 21.594v-3.047c0-.555.211-.825.641-.825.434 0 .648.27.648.825v3.047c0 .55-.214.824-.648.824-.422 0-.64-.274-.64-.824m-1.712-5.274c-.574.672-.863 1.602-.863 2.746v1.992c0 1.153.29 2.07.863 2.75.579.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.671.866-1.597.866-2.75v-1.992c0-1.16-.289-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.773.336-2.359 1.008m8.81-.781h2.565v9.062h-2.566zm7.733 0h2.57v9.062h-2.57zm8.372 6.055v-3.047c0-.555.207-.825.636-.825.434 0 .649.27.649.825v3.047c0 .55-.215.824-.649.824-.422 0-.636-.274-.636-.824m-1.715-5.274c-.574.672-.863 1.602-.863 2.746v1.992c0 1.153.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.362-1.008.575-.671.864-1.597.864-2.75v-1.992c0-1.16-.29-2.074-.864-2.746-.578-.672-1.363-1.008-2.363-1.008-.988 0-1.773.336-2.36 1.008m8.81-.781h2.57v9.062h-2.57zm7.738 0h2.566v9.062h-2.566zm7.734 0h2.566v9.062h-2.566zm7.727 0h2.57v9.062h-2.57zm-53.496 22.375v-3.047c0-.555.21-.824.64-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.273c-.574.671-.863 1.601-.863 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.867-1.598.867-2.75v-1.992c0-1.16-.29-2.075-.867-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.36 1.008m8.81-.782h2.566v9.063h-2.567zm7.734 0h2.57v9.063h-2.57zm8.37 6.055v-3.047c0-.555.208-.824.638-.824.433 0 .648.27.648.824v3.047c0 .55-.215.824-.648.824-.422 0-.637-.273-.637-.824m-1.715-5.273c-.574.671-.863 1.601-.863 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.289-2.075-.863-2.746-.578-.672-1.364-1.008-2.364-1.008-.988 0-1.773.336-2.359 1.008m8.809-.782h2.57v9.063h-2.57zm7.738 0h2.566v9.063h-2.566zm7.734 0h2.567v9.063h-2.567zm7.727 0h2.57v9.063h-2.57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h88v204H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.367 6.816V3.77c0-.555.207-.825.64-.825.434 0 .65.27.65.825v3.046c0 .551-.216.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.746v1.992c0 1.153.285 2.07.863 2.75.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.862-1.597.862-2.75V4.29c0-1.16-.285-2.074-.863-2.746C5.801.871 5.015.535 4.015.535c-.991 0-1.777.336-2.359 1.008m8.809-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062H18.2zm8.367 6.054V3.77c0-.555.211-.825.641-.825.434 0 .649.27.649.825v3.046c0 .551-.215.825-.649.825-.422 0-.64-.274-.64-.825m-1.711-5.273c-.575.672-.864 1.602-.864 2.746v1.992c0 1.153.29 2.07.864 2.75.578.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.578-.672.867-1.597.867-2.75V4.29c0-1.16-.29-2.074-.868-2.746C29 .871 28.215.535 27.215.535c-.992 0-1.773.336-2.36 1.008m8.81-.781h2.566v9.062h-2.567zm7.734 0h2.57v9.062h-2.57zm8.37 6.054V3.77c0-.555.208-.825.637-.825.434 0 .649.27.649.825v3.046c0 .551-.215.825-.649.825-.421 0-.636-.274-.636-.825m-1.715-5.273c-.574.672-.863 1.602-.863 2.746v1.992c0 1.153.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.785-.336 2.363-1.008.574-.671.863-1.597.863-2.75V4.29c0-1.16-.29-2.074-.863-2.746C52.199.871 51.414.535 50.414.535c-.988 0-1.773.336-2.36 1.008m9.442 5.273V3.77c0-.555.207-.825.64-.825.43 0 .65.27.65.825v3.046c0 .551-.22.825-.65.825-.425 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.746v1.992c0 1.153.285 2.07.863 2.75.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.573-.671.862-1.597.862-2.75V4.29c0-1.16-.289-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.776.336-2.359 1.008M3.367 23.137V20.09c0-.554.207-.824.641-.824.434 0 .648.27.648.824v3.047c0 .55-.214.824-.648.824-.422 0-.64-.273-.64-.824m-1.711-5.273c-.579.672-.864 1.601-.864 2.746v1.992c0 1.152.285 2.07.864 2.75.574.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.577-.672.863-1.598.863-2.75V20.61c0-1.16-.286-2.074-.864-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.776.336-2.358 1.008m8.808-.785h2.567v9.066h-2.567zm7.735 0h2.57v9.066H18.2zm8.367 6.058V20.09c0-.554.21-.824.64-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.273c-.574.672-.863 1.601-.863 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.867-1.598.867-2.75V20.61c0-1.16-.29-2.074-.867-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.36 1.008m8.81-.785h2.566v9.066h-2.567zm7.734 0h2.57v9.066H41.4zm7.738 0h2.567v9.066h-2.567zm7.727 0h2.57v9.066h-2.57zM3.368 39.458v-3.051c0-.551.207-.82.64-.82.434 0 .649.269.649.82v3.05c0 .551-.215.825-.649.825-.422 0-.64-.274-.64-.824m-1.711-5.274c-.578.672-.863 1.602-.863 2.746v1.992c0 1.149.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.671.863-1.601.863-2.75V36.93c0-1.16-.285-2.074-.863-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m8.81-.785h2.566v9.066h-2.567zm7.734 0h2.57v9.066H18.2zm7.738 0h2.567v9.066h-2.567zm8.36 6.059v-3.051c0-.551.207-.82.64-.82.43 0 .649.269.649.82v3.05c0 .551-.22.825-.649.825-.426 0-.64-.274-.64-.824m-1.711-5.274c-.579.672-.868 1.602-.868 2.746v1.993c0 1.148.29 2.07.868 2.75.574.671 1.359 1.007 2.359 1.007.992 0 1.781-.336 2.36-1.007.574-.672.863-1.602.863-2.75V36.93c0-1.16-.29-2.074-.864-2.746-.578-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008m9.446 5.274v-3.051c0-.551.207-.82.64-.82s.649.269.649.82v3.05c0 .551-.215.825-.648.825-.426 0-.641-.274-.641-.824m-1.711-5.274c-.578.672-.863 1.602-.863 2.746v1.993c0 1.148.285 2.07.863 2.75.574.671 1.36 1.007 2.36 1.007.992 0 1.785-.336 2.359-1.007.578-.672.863-1.602.863-2.75V36.93c0-1.16-.285-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.816-.785h2.567v9.066h-2.567zm8.36 6.059v-3.051c0-.55.207-.82.64-.82.43 0 .649.27.649.82v3.05c0 .551-.219.825-.649.825-.425 0-.64-.274-.64-.824m-1.711-5.274c-.578.672-.863 1.602-.863 2.746v1.993c0 1.148.285 2.07.863 2.75.574.671 1.36 1.007 2.36 1.007.991 0 1.785-.336 2.359-1.007.574-.672.863-1.602.863-2.75V36.93c0-1.16-.29-2.074-.863-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008M3.369 55.778v-3.05c0-.551.207-.825.64-.825.434 0 .649.274.649.824v3.051c0 .551-.215.824-.648.824-.422 0-.641-.273-.641-.824m-1.711-5.273c-.578.672-.863 1.601-.863 2.742v1.992c0 1.153.285 2.074.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.601.863-2.754v-1.992c0-1.156-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.785h2.566v9.066h-2.566zm7.734 0h2.57v9.066H18.2zm8.367 6.058v-3.05c0-.551.211-.825.64-.825.434 0 .65.274.65.825v3.05c0 .551-.216.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.575.672-.864 1.601-.864 2.742v1.992c0 1.153.29 2.074.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.601.866-2.754v-1.992c0-1.156-.289-2.07-.867-2.742-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.773.336-2.359 1.008m8.809-.785h2.566v9.066h-2.566zm8.367 6.058v-3.05c0-.551.207-.825.64-.825s.65.274.65.825v3.05c0 .551-.216.825-.65.825-.425 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.742v1.992c0 1.153.285 2.075.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.601.863-2.754v-1.992c0-1.156-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m9.45 5.273v-3.05c0-.551.206-.825.636-.825.434 0 .649.274.649.825v3.05c0 .551-.215.825-.649.825-.422 0-.637-.274-.637-.825m-1.714-5.273c-.575.672-.864 1.602-.864 2.742v1.992c0 1.153.29 2.075.864 2.754.578.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.363-1.008.575-.672.864-1.601.864-2.754v-1.992c0-1.156-.29-2.07-.864-2.742-.578-.672-1.363-1.008-2.363-1.008-.988 0-1.773.336-2.36 1.008m8.81-.785h2.57v9.066h-2.57zM3.367 72.099v-3.051c0-.55.207-.824.64-.824.434 0 .65.273.65.824v3.05c0 .552-.216.825-.65.825-.421 0-.64-.273-.64-.824m-1.71-5.274c-.579.672-.864 1.602-.864 2.743v1.992c0 1.152.285 2.074.863 2.754.575.672 1.36 1.007 2.36 1.007.992 0 1.785-.335 2.36-1.007.577-.672.862-1.602.862-2.754v-1.992c0-1.16-.285-2.07-.863-2.743-.574-.671-1.36-1.007-2.36-1.007-.991 0-1.777.336-2.359 1.007m8.809-.785h2.566v9.067h-2.566zm7.734 0h2.57v9.067H18.2zm8.368 6.059v-3.051c0-.55.21-.824.64-.824.434 0 .649.273.649.824v3.05c0 .552-.215.825-.649.825-.422 0-.64-.273-.64-.824m-1.711-5.274c-.575.672-.864 1.602-.864 2.743v1.992c0 1.152.29 2.074.864 2.754.578.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.578-.672.867-1.602.867-2.754v-1.992c0-1.16-.29-2.07-.868-2.743-.574-.671-1.359-1.007-2.359-1.007-.992 0-1.773.336-2.36 1.007m9.442 5.274v-3.051c0-.55.207-.824.64-.824.43 0 .65.273.65.824v3.05c0 .552-.22.825-.65.825-.425 0-.64-.273-.64-.824m-1.71-5.274c-.579.672-.868 1.602-.868 2.743v1.992c0 1.152.289 2.074.867 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.78-.336 2.359-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.289-2.07-.863-2.743-.578-.671-1.36-1.007-2.36-1.007-.992 0-1.777.336-2.359 1.007m9.445 5.274v-3.051c0-.55.207-.824.641-.824s.648.273.648.824v3.05c0 .552-.214.825-.648.825-.426 0-.64-.273-.64-.824m-1.711-5.274c-.579.672-.864 1.602-.864 2.743v1.992c0 1.152.285 2.074.864 2.754.574.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.577-.672.863-1.602.863-2.754v-1.992c0-1.16-.286-2.07-.864-2.743-.574-.671-1.36-1.007-2.36-1.007-.991 0-1.776.336-2.358 1.007M49.77 72.1v-3.051c0-.55.207-.824.636-.824.434 0 .649.273.649.824v3.05c0 .552-.215.825-.649.825-.421 0-.636-.273-.636-.824m-1.715-5.274c-.574.672-.863 1.602-.863 2.743v1.992c0 1.152.289 2.074.863 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.785-.336 2.363-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.743-.579-.671-1.364-1.007-2.364-1.007-.988 0-1.773.336-2.36 1.007m8.81-.785h2.57v9.067h-2.57zM3.369 88.415v-3.047c0-.55.207-.824.64-.824.434 0 .649.274.649.824v3.047c0 .555-.215.824-.649.824-.422 0-.64-.27-.64-.824m-1.711-5.27c-.579.673-.864 1.598-.864 2.743v1.992c0 1.152.285 2.074.864 2.754.574.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.578-.672.863-1.602.863-2.754v-1.992c0-1.16-.285-2.07-.864-2.742-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008m8.81-.785h2.566v9.066h-2.567zm7.734 0h2.57v9.066H18.2zm8.367 6.054v-3.047c0-.55.21-.824.64-.824.434 0 .649.274.649.824v3.047c0 .555-.215.825-.649.825-.421 0-.64-.27-.64-.825m-1.711-5.27c-.574.673-.863 1.599-.863 2.743v1.992c0 1.153.289 2.074.863 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.785-.336 2.359-1.008.578-.672.867-1.601.867-2.754v-1.992c0-1.16-.29-2.07-.867-2.742-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.36 1.008m8.81-.785h2.566v9.066h-2.566zm7.734 0h2.57v9.066H41.4zm8.371 6.054v-3.047c0-.55.207-.824.637-.824.433 0 .648.274.648.824v3.047c0 .555-.215.825-.648.825-.422 0-.637-.27-.637-.825m-1.715-5.27c-.574.673-.863 1.599-.863 2.743v1.992c0 1.153.289 2.074.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.601.863-2.754v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.363-1.008-2.363-1.008-.989 0-1.774.336-2.36 1.008m9.442 5.27v-3.048c0-.55.207-.824.64-.824.43 0 .649.274.649.824v3.047c0 .555-.22.825-.649.825-.426 0-.64-.27-.64-.825m-1.711-5.27c-.578.673-.864 1.599-.864 2.743v1.992c0 1.153.286 2.074.864 2.754.574.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.574-.672.863-1.601.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.742-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008M3.37 104.736v-3.047c0-.55.207-.824.64-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.422 0-.64-.27-.64-.824m-1.711-5.27c-.578.672-.863 1.598-.863 2.743v1.992c0 1.152.285 2.074.863 2.754.574.672 1.36 1.007 2.36 1.007.991 0 1.784-.335 2.359-1.007.578-.672.863-1.602.863-2.754v-1.992c0-1.16-.285-2.07-.863-2.743-.575-.672-1.36-1.007-2.36-1.007-.992 0-1.777.335-2.36 1.007m8.81-.785h2.566v9.063h-2.567zm7.734 0h2.57v9.063h-2.57zm8.367 6.055v-3.047c0-.55.21-.824.64-.824.434 0 .65.273.65.824v3.047c0 .555-.216.824-.65.824-.421 0-.64-.27-.64-.824m-1.71-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.289 2.074.863 2.754.578.672 1.36 1.007 2.36 1.007.992 0 1.785-.335 2.359-1.007.578-.672.867-1.602.867-2.754v-1.992c0-1.16-.289-2.07-.867-2.743-.574-.671-1.36-1.007-2.36-1.007-.992 0-1.773.336-2.359 1.007m8.809-.785h2.566v9.063h-2.566zm7.734 0h2.57v9.063H41.4zm7.738 0h2.567v9.063h-2.567zm7.727 0h2.57v9.063h-2.57zM3.369 121.056v-3.047c0-.55.207-.824.64-.824.434 0 .65.274.65.824v3.047c0 .555-.216.824-.65.824-.421 0-.64-.27-.64-.824m-1.71-5.27c-.579.673-.864 1.598-.864 2.743v1.992c0 1.153.285 2.074.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.602.863-2.754v-1.992c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.785h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm7.738 0h2.567v9.062h-2.567zm8.36 6.054v-3.047c0-.55.207-.824.64-.824.43 0 .649.274.649.824v3.047c0 .555-.219.824-.649.824-.425 0-.64-.269-.64-.824m-1.711-5.27c-.578.673-.867 1.598-.867 2.743v1.992c0 1.153.289 2.074.867 2.754.574.672 1.36 1.008 2.36 1.008.991 0 1.78-.336 2.359-1.008.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.742-.578-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m9.446 5.27v-3.048c0-.55.207-.824.64-.824s.65.274.65.824v3.047c0 .555-.216.824-.65.824-.425 0-.64-.269-.64-.824m-1.71-5.27c-.579.673-.864 1.598-.864 2.743v1.992c0 1.153.285 2.074.863 2.754.575.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.862-1.602.862-2.754v-1.992c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m8.817-.785h2.566v9.062H49.14zm8.36 6.054v-3.047c0-.55.206-.824.64-.824.43 0 .648.274.648.824v3.047c0 .555-.219.825-.648.825-.426 0-.64-.27-.64-.825m-1.712-5.27c-.578.673-.863 1.598-.863 2.743v1.992c0 1.153.285 2.074.863 2.754.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.574-.672.863-1.601.863-2.754v-1.992c0-1.16-.289-2.07-.863-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008M3.37 137.377v-3.047c0-.55.207-.824.64-.824.434 0 .65.273.65.824v3.047c0 .554-.216.824-.65.824-.421 0-.64-.27-.64-.824m-1.71-5.27c-.579.672-.864 1.598-.864 2.743v1.992c0 1.152.285 2.07.863 2.754.575.671 1.36 1.007 2.36 1.007.992 0 1.785-.336 2.36-1.007.577-.672.862-1.602.862-2.754v-1.993c0-1.16-.285-2.07-.863-2.742-.574-.672-1.36-1.007-2.36-1.007-.991 0-1.777.335-2.359 1.007m8.809-.785h2.566v9.063h-2.566zm7.734 0h2.57v9.063h-2.57zm8.368 6.055v-3.047c0-.55.21-.824.64-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.422 0-.64-.27-.64-.824m-1.711-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.29 2.07.864 2.754.578.672 1.359 1.007 2.359 1.007.992 0 1.785-.336 2.36-1.007.578-.672.867-1.602.867-2.754v-1.992c0-1.16-.29-2.07-.868-2.743-.574-.672-1.359-1.007-2.359-1.007-.992 0-1.773.335-2.36 1.007m8.81-.785h2.566v9.063h-2.567zm8.366 6.055v-3.047c0-.55.207-.824.641-.824s.648.273.648.824v3.047c0 .555-.214.824-.648.824-.426 0-.64-.27-.64-.824m-1.711-5.27c-.579.672-.864 1.598-.864 2.743v1.992c0 1.152.285 2.07.864 2.754.574.672 1.359 1.007 2.359 1.007.992 0 1.785-.335 2.36-1.007.577-.672.863-1.602.863-2.754v-1.992c0-1.16-.286-2.07-.864-2.743-.574-.671-1.36-1.007-2.36-1.007-.991 0-1.776.336-2.358 1.007m9.449 5.27v-3.047c0-.55.207-.824.636-.824.434 0 .649.273.649.824v3.047c0 .555-.215.824-.649.824-.421 0-.636-.27-.636-.824m-1.715-5.27c-.574.672-.863 1.598-.863 2.743v1.992c0 1.152.289 2.07.863 2.754.578.672 1.36 1.007 2.36 1.007.991 0 1.785-.335 2.363-1.007.574-.672.863-1.602.863-2.754v-1.992c0-1.16-.29-2.07-.863-2.743-.579-.671-1.364-1.007-2.364-1.007-.988 0-1.773.336-2.36 1.007m8.81-.785h2.57v9.063h-2.57zM3.37 153.697v-3.047c0-.55.207-.824.64-.824.434 0 .649.274.649.824v3.047c0 .551-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.27c-.579.673-.864 1.598-.864 2.743v1.992c0 1.152.285 2.07.864 2.75.574.676 1.359 1.012 2.359 1.012.992 0 1.785-.336 2.36-1.012.578-.672.863-1.598.863-2.75v-1.992c0-1.16-.285-2.07-.864-2.742-.574-.672-1.359-1.012-2.359-1.012-.992 0-1.777.34-2.36 1.012m8.81-.785h2.566v9.062h-2.567zm7.734 0h2.57v9.062h-2.57zm8.367 6.054v-3.047c0-.55.21-.824.64-.824.434 0 .649.274.649.824v3.047c0 .551-.215.824-.649.824-.421 0-.64-.273-.64-.824m-1.711-5.27c-.574.673-.863 1.598-.863 2.743v1.992c0 1.152.289 2.07.863 2.75.578.676 1.36 1.012 2.36 1.012.991 0 1.785-.336 2.359-1.012.578-.672.867-1.598.867-2.75v-1.992c0-1.16-.29-2.07-.867-2.742-.575-.672-1.36-1.012-2.36-1.012-.992 0-1.773.34-2.36 1.012m9.442 5.27v-3.048c0-.55.207-.824.64-.824.43 0 .65.274.65.824v3.047c0 .551-.22.824-.65.824-.425 0-.64-.273-.64-.824m-1.71-5.27c-.579.673-.868 1.598-.868 2.743v1.992c0 1.152.29 2.07.867 2.75.575.676 1.36 1.012 2.36 1.012.992 0 1.781-.336 2.36-1.012.573-.672.862-1.598.862-2.75v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.36-1.012-2.36-1.012-.991 0-1.776.34-2.359 1.012m9.446 5.27v-3.048c0-.55.207-.824.64-.824s.649.274.649.824v3.047c0 .551-.215.824-.649.824-.425 0-.64-.273-.64-.824m-1.711-5.27c-.578.673-.863 1.598-.863 2.743v1.992c0 1.152.285 2.07.863 2.75.574.676 1.36 1.012 2.36 1.012.991 0 1.784-.336 2.359-1.012.578-.672.863-1.598.863-2.75v-1.992c0-1.16-.285-2.07-.863-2.742-.575-.672-1.36-1.012-2.36-1.012-.992 0-1.777.34-2.36 1.012m9.45 5.27v-3.048c0-.55.207-.824.637-.824.433 0 .648.274.648.824v3.047c0 .551-.215.824-.648.824-.422 0-.637-.273-.637-.824m-1.715-5.27c-.574.673-.863 1.598-.863 2.743v1.992c0 1.152.289 2.07.863 2.75.578.676 1.36 1.012 2.36 1.012.992 0 1.785-.336 2.363-1.012.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.363-1.012-2.363-1.012-.989 0-1.774.34-2.36 1.012m8.809-.785h2.57v9.062h-2.57zM3.37 170.018v-3.047c0-.555.207-.825.64-.825.434 0 .649.27.649.825v3.047c0 .55-.215.824-.649.824-.421 0-.64-.274-.64-.824m-1.711-5.274c-.578.672-.863 1.602-.863 2.746v1.993c0 1.152.285 2.07.863 2.75.574.671 1.36 1.007 2.36 1.007.991 0 1.785-.336 2.359-1.007.578-.672.863-1.598.863-2.75v-1.993c0-1.16-.285-2.074-.863-2.746-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.36 1.008m8.81-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.367 6.055v-3.047c0-.555.211-.824.64-.824.434 0 .65.27.65.824v3.047c0 .55-.216.824-.65.824-.421 0-.64-.274-.64-.824m-1.71-5.274c-.575.672-.864 1.602-.864 2.746v1.993c0 1.152.289 2.07.863 2.75.578.671 1.36 1.007 2.36 1.007.992 0 1.785-.336 2.359-1.007.578-.672.867-1.598.867-2.75v-1.993c0-1.16-.289-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.359 1.008m8.809-.781h2.566v9.063h-2.566zm7.734 0h2.57v9.063h-2.57zm8.371 6.055v-3.047c0-.555.207-.824.637-.824.434 0 .648.27.648.824v3.047c0 .55-.214.824-.648.824-.422 0-.637-.274-.637-.824m-1.714-5.274c-.575.672-.864 1.602-.864 2.746v1.993c0 1.152.29 2.07.864 2.75.578.671 1.359 1.007 2.359 1.007.992 0 1.785-.336 2.363-1.007.574-.672.863-1.598.863-2.75v-1.993c0-1.16-.289-2.074-.863-2.746-.578-.672-1.363-1.007-2.363-1.007-.988 0-1.773.335-2.36 1.007m9.442 5.274v-3.047c0-.555.207-.824.64-.824.43 0 .649.27.649.824v3.047c0 .55-.219.824-.648.824-.426 0-.641-.274-.641-.824m-1.711-5.274c-.578.672-.863 1.602-.863 2.746v1.993c0 1.152.285 2.07.863 2.75.574.671 1.36 1.007 2.36 1.007.992 0 1.785-.336 2.359-1.007.574-.672.863-1.598.863-2.75v-1.993c0-1.16-.289-2.074-.863-2.746-.574-.672-1.36-1.007-2.36-1.007-.992 0-1.777.335-2.359 1.007M3.37 186.338v-3.047c0-.554.207-.824.64-.824.434 0 .65.27.65.824v3.047c0 .551-.216.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.579.672-.864 1.602-.864 2.746v1.992c0 1.153.285 2.07.863 2.75.574.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.863-1.597.863-2.75v-1.992c0-1.16-.285-2.074-.863-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m8.809-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.367 6.054v-3.047c0-.554.211-.824.64-.824.435 0 .65.27.65.824v3.047c0 .551-.215.825-.65.825-.421 0-.64-.274-.64-.825m-1.71-5.273c-.575.672-.864 1.602-.864 2.746v1.992c0 1.153.29 2.07.863 2.75.579.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.597.866-2.75v-1.992c0-1.16-.289-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.773.336-2.359 1.008m8.809-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm7.739 0h2.566v9.062H49.14zm7.726 0h2.57v9.062h-2.57zM3.37 202.659v-3.047c0-.555.207-.824.64-.824.435 0 .65.27.65.824v3.047c0 .55-.215.824-.65.824-.42 0-.64-.274-.64-.824m-1.71-5.274c-.579.672-.864 1.602-.864 2.746v1.993c0 1.152.285 2.07.863 2.75.575.671 1.36 1.007 2.36 1.007.992 0 1.785-.336 2.36-1.007.577-.672.862-1.598.862-2.75v-1.993c0-1.16-.285-2.074-.863-2.746-.574-.672-1.36-1.007-2.36-1.007-.991 0-1.776.335-2.359 1.007m8.809-.78h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm7.739 0h2.566v9.062h-2.566zm8.36 6.054v-3.047c0-.555.206-.824.64-.824.43 0 .648.27.648.824v3.047c0 .55-.219.824-.648.824-.426 0-.64-.273-.64-.824m-1.712-5.274c-.578.672-.867 1.602-.867 2.746v1.993c0 1.152.29 2.07.867 2.75.574.672 1.36 1.007 2.36 1.007.992 0 1.78-.335 2.359-1.007.574-.672.863-1.598.863-2.75v-1.993c0-1.16-.289-2.074-.863-2.746-.578-.672-1.36-1.007-2.36-1.007-.992 0-1.777.335-2.359 1.007m9.446 5.274v-3.047c0-.555.207-.824.64-.824s.649.27.649.824v3.047c0 .55-.215.824-.649.824-.426 0-.64-.273-.64-.824m-1.711-5.274c-.579.672-.864 1.602-.864 2.746v1.993c0 1.152.285 2.07.864 2.75.574.672 1.359 1.007 2.359 1.007.992 0 1.785-.335 2.36-1.007.578-.672.863-1.598.863-2.75v-1.993c0-1.16-.285-2.074-.864-2.746-.574-.672-1.359-1.007-2.359-1.007-.992 0-1.777.335-2.36 1.007m8.817-.78h2.566v9.062H49.14zm8.36 6.054v-3.047c0-.555.206-.824.64-.824.43 0 .648.27.648.824v3.047c0 .55-.218.824-.648.824-.426 0-.64-.273-.64-.824m-1.711-5.274c-.579.672-.864 1.602-.864 2.746v1.993c0 1.152.285 2.07.864 2.75.574.672 1.359 1.007 2.359 1.007.992 0 1.785-.335 2.36-1.007.574-.672.863-1.598.863-2.75v-1.993c0-1.16-.29-2.074-.864-2.746-.574-.671-1.36-1.007-2.36-1.007-.991 0-1.776.336-2.358 1.007m9.445-60.008v-3.047c0-.55.21-.824.64-.824.434 0 .649.274.649.824v3.047c0 .555-.215.825-.649.825-.421 0-.64-.27-.64-.825m-1.711-5.27c-.574.673-.863 1.598-.863 2.743v1.992c0 1.153.289 2.07.863 2.754.578.672 1.36 1.008 2.36 1.008.991 0 1.785-.336 2.359-1.008.578-.672.867-1.601.867-2.754v-1.992c0-1.16-.29-2.07-.867-2.742-.575-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.36 1.008m8.81-.785h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.371 6.054v-3.046c0-.551.207-.825.637-.825.433 0 .648.274.648.825v3.046c0 .555-.215.825-.648.825-.422 0-.637-.27-.637-.825m-1.715-5.27c-.574.673-.863 1.599-.863 2.743v1.992c0 1.153.289 2.07.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.601.863-2.754v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.363-1.008-2.363-1.008-.989 0-1.774.336-2.36 1.008m8.809-.785h2.57v9.062h-2.57zm8.367 6.054v-3.046c0-.551.21-.825.64-.825.434 0 .65.274.65.825v3.046c0 .555-.216.825-.65.825-.421 0-.64-.27-.64-.825m-1.71-5.269c-.575.672-.864 1.598-.864 2.742v1.992c0 1.153.289 2.07.863 2.754.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.867-1.601.867-2.754v-1.992c0-1.16-.289-2.07-.867-2.742-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.359 1.008m9.45 5.27v-3.047c0-.551.206-.825.64-.825.43 0 .648.274.648.825v3.046c0 .555-.218.825-.648.825-.426 0-.64-.27-.64-.825m-1.712-5.269c-.578.672-.867 1.598-.867 2.742v1.992c0 1.153.29 2.07.867 2.754.575.672 1.36 1.008 2.36 1.008.992 0 1.781-.336 2.36-1.008.573-.672.862-1.601.862-2.754v-1.992c0-1.16-.289-2.07-.863-2.742-.578-.672-1.36-1.008-2.36-1.008-.991 0-1.777.336-2.359 1.008m8.805-.785h2.57v9.062h-2.57zm-53.496 22.375v-3.047c0-.55.211-.824.64-.824.434 0 .65.273.65.824v3.047c0 .55-.216.824-.65.824-.421 0-.64-.273-.64-.824m-1.71-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.289 2.07.863 2.75.578.675 1.36 1.011 2.36 1.011.992 0 1.785-.336 2.359-1.011.578-.672.867-1.598.867-2.75v-1.992c0-1.16-.289-2.07-.867-2.743-.574-.672-1.36-1.011-2.36-1.011-.992 0-1.773.34-2.359 1.011m8.809-.785h2.566v9.063h-2.566zm7.734 0h2.57v9.063h-2.57zm8.371 6.055v-3.047c0-.55.207-.824.637-.824.434 0 .648.273.648.824v3.047c0 .55-.214.824-.648.824-.422 0-.637-.273-.637-.824m-1.714-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.29 2.07.864 2.75.578.676 1.359 1.011 2.359 1.011.992 0 1.785-.335 2.363-1.011.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.289-2.07-.863-2.743-.578-.672-1.363-1.011-2.363-1.011-.988 0-1.773.34-2.36 1.011m9.442 5.27v-3.047c0-.55.207-.824.64-.824.43 0 .649.273.649.824v3.047c0 .55-.219.824-.648.824-.426 0-.641-.273-.641-.824m-1.711-5.27c-.578.672-.863 1.598-.863 2.743v1.992c0 1.152.285 2.07.863 2.75.574.676 1.36 1.011 2.36 1.011.992 0 1.785-.335 2.359-1.011.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.289-2.07-.863-2.743-.574-.672-1.36-1.011-2.36-1.011-.992 0-1.777.34-2.359 1.011m9.445 5.27v-3.047c0-.55.211-.824.64-.824.435 0 .65.273.65.824v3.047c0 .55-.215.824-.65.824-.42 0-.64-.273-.64-.824m-1.71-5.27c-.575.672-.864 1.598-.864 2.743v1.992c0 1.152.29 2.07.863 2.75.579.676 1.36 1.011 2.36 1.011.992 0 1.785-.335 2.36-1.011.577-.672.866-1.598.866-2.75v-1.992c0-1.16-.289-2.07-.867-2.743-.574-.672-1.36-1.011-2.36-1.011-.991 0-1.773.34-2.359 1.011m9.45 5.27v-3.047c0-.55.207-.824.64-.824.43 0 .649.273.649.824v3.047c0 .55-.22.824-.649.824-.426 0-.64-.273-.64-.824m-1.711-5.27c-.578.672-.867 1.598-.867 2.743v1.992c0 1.152.289 2.07.867 2.75.574.676 1.36 1.011 2.36 1.011.991 0 1.78-.335 2.359-1.011.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.29-2.07-.863-2.743-.579-.672-1.36-1.011-2.36-1.011-.992 0-1.777.34-2.36 1.011m8.805-.785h2.57v9.063h-2.57zm-53.496 22.375v-3.047c0-.554.211-.824.641-.824.434 0 .648.27.648.824v3.047c0 .551-.214.824-.648.824-.422 0-.64-.273-.64-.824m-1.711-5.273c-.575.672-.864 1.601-.864 2.746v1.992c0 1.152.29 2.07.864 2.75.578.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.577-.672.866-1.598.866-2.75v-1.992c0-1.16-.289-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.991 0-1.772.336-2.358 1.008m8.808-.781H74.9v9.062h-2.567zm7.735 0h2.57v9.062h-2.57zm8.37 6.054v-3.047c0-.554.208-.824.637-.824.434 0 .649.27.649.824v3.047c0 .551-.215.824-.649.824-.422 0-.636-.273-.636-.824m-1.715-5.273c-.574.672-.863 1.601-.863 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.363-1.008.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.29-2.074-.863-2.746-.579-.672-1.364-1.008-2.364-1.008-.988 0-1.773.336-2.36 1.008m8.81-.781h2.57v9.062h-2.57zm7.738 0h2.566v9.062h-2.566zm8.367 6.054v-3.047c0-.554.207-.824.64-.824.43 0 .649.27.649.824v3.047c0 .551-.219.825-.648.825-.426 0-.641-.274-.641-.825m-1.711-5.273c-.578.672-.867 1.601-.867 2.746v1.992c0 1.153.289 2.07.867 2.75.574.672 1.36 1.008 2.36 1.008.992 0 1.78-.336 2.359-1.008.574-.672.863-1.597.863-2.75v-1.992c0-1.16-.289-2.074-.863-2.746-.578-.672-1.36-1.008-2.36-1.008-.992 0-1.777.336-2.359 1.008m9.438 5.273v-3.047c0-.554.207-.824.64-.824s.649.27.649.824v3.047c0 .551-.215.825-.649.825-.426 0-.64-.274-.64-.825m-1.711-5.273c-.579.672-.864 1.601-.864 2.746v1.992c0 1.153.285 2.07.864 2.75.574.672 1.359 1.008 2.359 1.008.992 0 1.785-.336 2.36-1.008.578-.672.863-1.597.863-2.75v-1.992c0-1.16-.285-2.074-.864-2.746-.574-.672-1.359-1.008-2.359-1.008-.992 0-1.777.336-2.36 1.008m-52.417 21.594v-3.047c0-.555.21-.824.64-.824.434 0 .649.27.649.824v3.047c0 .55-.215.824-.649.824-.422 0-.64-.273-.64-.824m-1.711-5.274c-.575.672-.864 1.602-.864 2.747v1.992c0 1.152.29 2.07.864 2.75.578.672 1.36 1.008 2.36 1.008.991 0 1.784-.336 2.359-1.008.578-.672.867-1.598.867-2.75v-1.992c0-1.16-.29-2.075-.867-2.747-.575-.671-1.36-1.007-2.36-1.007-.992 0-1.773.336-2.36 1.007m8.81-.78h2.566v9.062h-2.567zm7.734 0h2.57v9.062h-2.57zm8.37 6.054v-3.047c0-.555.208-.824.638-.824.433 0 .648.27.648.824v3.047c0 .55-.215.824-.648.824-.422 0-.637-.273-.637-.824m-1.715-5.273c-.574.671-.863 1.601-.863 2.746v1.992c0 1.152.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.598.863-2.75v-1.992c0-1.16-.29-2.075-.863-2.746-.578-.672-1.364-1.008-2.364-1.008-.988 0-1.773.336-2.359 1.008m8.809-.782h2.57v9.063h-2.57zm7.738 0h2.566v9.063h-2.566zm7.734 0h2.567v9.063h-2.567zm7.727 0h2.57v9.063h-2.57zM65.235 202.66v-3.047c0-.554.21-.824.64-.824.434 0 .649.27.649.824v3.047c0 .551-.215.825-.648.825-.422 0-.641-.274-.641-.825m-1.711-5.273c-.574.672-.863 1.601-.863 2.746v1.992c0 1.153.289 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.359-1.008.578-.672.867-1.597.867-2.75v-1.992c0-1.16-.29-2.074-.867-2.746-.574-.672-1.36-1.008-2.36-1.008-.992 0-1.773.336-2.359 1.008m8.809-.781h2.566v9.062h-2.566zm7.734 0h2.57v9.062h-2.57zm8.371 6.054v-3.047c0-.554.207-.824.637-.824.433 0 .648.27.648.824v3.047c0 .551-.215.825-.648.825-.422 0-.637-.274-.637-.825m-1.715-5.273c-.574.672-.863 1.602-.863 2.746v1.992c0 1.153.29 2.07.863 2.75.578.672 1.36 1.008 2.36 1.008.992 0 1.785-.336 2.363-1.008.574-.672.863-1.597.863-2.75v-1.992c0-1.16-.289-2.074-.863-2.746-.578-.672-1.363-1.008-2.363-1.008-.989 0-1.774.336-2.36 1.008m8.809-.781h2.57v9.062h-2.57zm7.738 0h2.567v9.062h-2.567zm7.735 0h2.566v9.062h-2.566zm7.726 0h2.57v9.062h-2.57z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.625-1.625v131.67c0 23.051 6.207 41.059 18.633 54.031 12.422 12.977 29.773 19.465 52.008 19.465h16.23V143.99h-3.152c-9.016 0-15.055-1.578-18.113-4.734-3.055-3.153-4.582-9.489-4.582-19.012V-1.626z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v206H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 295.72,
    x2: 104.45,
    y1: 154.31,
    y2: 154.31,
    gradientTransform: "matrix(.8 0 0 .8 -83 -95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41aade",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41aade",
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42a9dd",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42a9dd",
    offset: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43a9dd",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43a8dd",
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44a8dc",
    offset: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44a8dc",
    offset: 0.027
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45a7dc",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45a7dc",
    offset: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a7db",
    offset: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a7db",
    offset: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a6db",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a6db",
    offset: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a6da",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a5da",
    offset: 0.059
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49a5da",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aa5da",
    offset: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aa4d9",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ba4d9",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ba4d9",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ca4d9",
    offset: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ca3d8",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4da3d8",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4da3d8",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ea2d7",
    offset: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ea2d7",
    offset: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fa2d7",
    offset: 0.105
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fa2d7",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50a1d6",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50a1d6",
    offset: 0.117
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51a1d6",
    offset: 0.121
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52a0d6",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52a0d5",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53a0d5",
    offset: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#539fd5",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549fd5",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549fd4",
    offset: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559fd4",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559ed4",
    offset: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569ed4",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569ed3",
    offset: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579dd3",
    offset: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579dd3",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589dd2",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589dd2",
    offset: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599cd2",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599cd2",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a9cd1",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5b9bd1",
    offset: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5b9bd1",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9bd1",
    offset: 0.199
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9ad0",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5d9ad0",
    offset: 0.207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5d9ad0",
    offset: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e9ad0",
    offset: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e99cf",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f99cf",
    offset: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f99cf",
    offset: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6098cf",
    offset: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6098ce",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6198ce",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6198ce",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6297ce",
    offset: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6297cd",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6397cd",
    offset: 0.254
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6496cd",
    offset: 0.258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6496cc",
    offset: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6596cc",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6595cc",
    offset: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695cc",
    offset: 0.273
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695cb",
    offset: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6795cb",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6794cb",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6894cb",
    offset: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6894ca",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6993ca",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6993ca",
    offset: 0.301
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6a93ca",
    offset: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6a92c9",
    offset: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6b92c9",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6c92c9",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6c92c9",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d91c8",
    offset: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d91c8",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6e91c8",
    offset: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6e90c8",
    offset: 0.336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6f90c7",
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6f90c7",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7090c7",
    offset: 0.348
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#708fc6",
    offset: 0.352
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718fc6",
    offset: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718fc6",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728ec6",
    offset: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728ec5",
    offset: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738ec5",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738dc5",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748dc5",
    offset: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758dc4",
    offset: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758dc4",
    offset: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#768cc4",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#768cc4",
    offset: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778cc3",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778bc3",
    offset: 0.402
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#788bc3",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#788bc3",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798bc2",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798ac2",
    offset: 0.418
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7a8ac2",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7a8ac1",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7b89c1",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7b89c1",
    offset: 0.434
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c89c1",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c88c0",
    offset: 0.441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d88c0",
    offset: 0.445
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e88c0",
    offset: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e88c0",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7f87bf",
    offset: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7f87bf",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8087bf",
    offset: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8086bf",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8186be",
    offset: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8186be",
    offset: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8286be",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8285be",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8385bd",
    offset: 0.488
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8385bd",
    offset: 0.492
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8484bd",
    offset: 0.496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8484bd",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8584bc",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8683bc",
    offset: 0.508
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8683bc",
    offset: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8783bb",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8783bb",
    offset: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8882bb",
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8882bb",
    offset: 0.527
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8982ba",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8981ba",
    offset: 0.535
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a81ba",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a81ba",
    offset: 0.543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8b80b9",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8b80b9",
    offset: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8c80b9",
    offset: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8c80b9",
    offset: 0.559
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8d7fb8",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8d7fb8",
    offset: 0.566
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8e7fb8",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f7eb8",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f7eb7",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907eb7",
    offset: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907eb7",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917db7",
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917db6",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#927db6",
    offset: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#927cb6",
    offset: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#937cb5",
    offset: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#937cb5",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947bb5",
    offset: 0.613
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947bb5",
    offset: 0.617
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#957bb4",
    offset: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#957bb4",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967ab4",
    offset: 0.629
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967ab4",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977ab3",
    offset: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9879b3",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9879b3",
    offset: 0.645
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9979b3",
    offset: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9979b2",
    offset: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9a78b2",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9a78b2",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b78b2",
    offset: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b77b1",
    offset: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c77b1",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c77b1",
    offset: 0.676
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d76b0",
    offset: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d76b0",
    offset: 0.684
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e76b0",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e76b0",
    offset: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f75af",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f75af",
    offset: 0.699
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a075af",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a174af",
    offset: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a174ae",
    offset: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a274ae",
    offset: 0.715
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a274ae",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a373ae",
    offset: 0.723
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a373ad",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a473ad",
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a472ad",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a572ad",
    offset: 0.738
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a572ac",
    offset: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a671ac",
    offset: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a671ac",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a771ac",
    offset: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a771ab",
    offset: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a870ab",
    offset: 0.762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a970ab",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a970aa",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aa6faa",
    offset: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aa6faa",
    offset: 0.777
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ab6faa",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ab6ea9",
    offset: 0.785
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ac6ea9",
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ac6ea9",
    offset: 0.793
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ad6ea9",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ad6da8",
    offset: 0.801
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ae6da8",
    offset: 0.805
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ae6da8",
    offset: 0.809
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af6ca8",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af6ca7",
    offset: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b06ca7",
    offset: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b06ca7",
    offset: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b16ba7",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b26ba6",
    offset: 0.832
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b26ba6",
    offset: 0.836
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b36aa6",
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b36aa6",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b46aa5",
    offset: 0.848
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b469a5",
    offset: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b569a5",
    offset: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b569a4",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b669a4",
    offset: 0.863
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b668a4",
    offset: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b768a4",
    offset: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b768a3",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b867a3",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b867a3",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b967a3",
    offset: 0.887
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b967a2",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba66a2",
    offset: 0.895
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bb66a2",
    offset: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bb66a2",
    offset: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bc65a1",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bc65a1",
    offset: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bd65a1",
    offset: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bd64a1",
    offset: 0.918
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#be64a0",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#be64a0",
    offset: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf64a0",
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf63a0",
    offset: 0.934
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0639f",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0639f",
    offset: 0.941
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1629f",
    offset: 0.945
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1629e",
    offset: 0.949
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2629e",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3629e",
    offset: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3619e",
    offset: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4619d",
    offset: 0.965
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4619d",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5609d",
    offset: 0.973
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5609d",
    offset: 0.977
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6609c",
    offset: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c65f9c",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c75f9c",
    offset: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c75f9c",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c85f9b",
    offset: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c85e9b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 20,
    x2: 20,
    y1: 271.93,
    y2: 18.169,
    gradientTransform: "matrix(.8 0 0 .8 -13 -14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a7db",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a6db",
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a6db",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a6da",
    offset: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49a5da",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49a5da",
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aa5d9",
    offset: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ba4d9",
    offset: 0.027
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ba4d9",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ca3d8",
    offset: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4da3d8",
    offset: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4da3d8",
    offset: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ea2d7",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fa2d7",
    offset: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fa2d7",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50a1d6",
    offset: 0.059
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51a1d6",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51a1d6",
    offset: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52a0d5",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53a0d5",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#539fd5",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549fd4",
    offset: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559fd4",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559ed4",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569ed3",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579ed3",
    offset: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579dd3",
    offset: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589dd2",
    offset: 0.105
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599cd2",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599cd2",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a9cd1",
    offset: 0.117
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5b9bd1",
    offset: 0.121
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5b9bd1",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9bd0",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5d9ad0",
    offset: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5d9ad0",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e99cf",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f99cf",
    offset: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5f99cf",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6098ce",
    offset: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6198ce",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6198ce",
    offset: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6297cd",
    offset: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6397cd",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6396cd",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6496cd",
    offset: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6596cc",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6595cc",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695cc",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6795cb",
    offset: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6794cb",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6894cb",
    offset: 0.199
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6993ca",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6993ca",
    offset: 0.207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6a93ca",
    offset: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6b92c9",
    offset: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6b92c9",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6c92c9",
    offset: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d91c8",
    offset: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6d91c8",
    offset: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6e90c8",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6f90c7",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6f90c7",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#708fc7",
    offset: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718fc6",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#718fc6",
    offset: 0.254
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728ec6",
    offset: 0.258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738ec5",
    offset: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738dc5",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748dc5",
    offset: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758dc4",
    offset: 0.273
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#758cc4",
    offset: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#768cc4",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778cc3",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778bc3",
    offset: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#788bc3",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798bc2",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798ac2",
    offset: 0.301
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7a8ac2",
    offset: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7b89c1",
    offset: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7b89c1",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c89c1",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7d88c0",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e88c0",
    offset: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e88c0",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7f87bf",
    offset: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8087bf",
    offset: 0.336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8086bf",
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8186be",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8286be",
    offset: 0.348
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8285be",
    offset: 0.352
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8385bd",
    offset: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8485bd",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8484bd",
    offset: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8584bc",
    offset: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8683bc",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8683bc",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8783bb",
    offset: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8882bb",
    offset: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8882bb",
    offset: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8982ba",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a81ba",
    offset: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a81ba",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8b80b9",
    offset: 0.402
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8c80b9",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8c80b9",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8d7fb8",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8e7fb8",
    offset: 0.418
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8e7fb8",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8f7eb7",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907eb7",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#907db7",
    offset: 0.434
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917db6",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#927db6",
    offset: 0.441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#927cb6",
    offset: 0.445
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#937cb5",
    offset: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947cb5",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#947bb5",
    offset: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#957bb4",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967ab4",
    offset: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967ab4",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977ab3",
    offset: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9879b3",
    offset: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9879b3",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9979b2",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9a78b2",
    offset: 0.488
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9a78b2",
    offset: 0.492
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b77b1",
    offset: 0.496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c77b1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c77b1",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d76b0",
    offset: 0.508
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e76b0",
    offset: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e76b0",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f75af",
    offset: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a075af",
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a074af",
    offset: 0.527
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a174ae",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a274ae",
    offset: 0.535
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a273ae",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a373ad",
    offset: 0.543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a473ad",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a472ad",
    offset: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a572ac",
    offset: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a672ac",
    offset: 0.559
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a671ac",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a771ab",
    offset: 0.566
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a870ab",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a870ab",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a970aa",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aa6faa",
    offset: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aa6faa",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ab6fa9",
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ac6ea9",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ac6ea9",
    offset: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ad6da8",
    offset: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ae6da8",
    offset: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ae6da8",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af6ca7",
    offset: 0.613
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b06ca7",
    offset: 0.617
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b06ca7",
    offset: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b16ba7",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b26ba6",
    offset: 0.629
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b26aa6",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b36aa6",
    offset: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b46aa5",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b469a5",
    offset: 0.645
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b569a5",
    offset: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b669a4",
    offset: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b668a4",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b768a4",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b867a3",
    offset: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b867a3",
    offset: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b967a3",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba66a2",
    offset: 0.676
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba66a2",
    offset: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bb66a2",
    offset: 0.684
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bc65a1",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bd65a1",
    offset: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bd64a1",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#be64a0",
    offset: 0.699
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf64a0",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bf63a0",
    offset: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0639f",
    offset: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1639f",
    offset: 0.715
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1629f",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2629e",
    offset: 0.723
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3619e",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3619e",
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4619d",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5609d",
    offset: 0.738
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5609d",
    offset: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6609c",
    offset: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c75f9c",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c75f9c",
    offset: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c85e9b",
    offset: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c95e9b",
    offset: 0.762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c95e9b",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ca5d9a",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cb5d9a",
    offset: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cb5d9a",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cb5c99",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cb5c99",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cb5c99",
    offset: 1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.559.2V57h153.02V.2z",
    fill: "url(#c)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    id: "n"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.793.535v203.01h86.703V.535z",
    fill: "url(#h)"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(-5.435 -5.728) scale(.39407)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(83 95)",
    width: "100%",
    height: "100%",
    xlinkHref: "#k"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "translate(-5.435 -5.728) scale(.39407)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(13 14)",
    width: "100%",
    height: "100%",
    xlinkHref: "#n"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoria);
export default __webpack_public_path__ + "static/media/logo-loria.d9b3a4e2060e51449131789dcf007dca.svg";
export { ForwardRef as ReactComponent };